var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisibilityOff = function SvgVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M17.905 14.523c.346-.356.877-1.137 1.595-2.344-.55-1.489-1.545-2.689-2.982-3.6-1.637-1.134-4.384-1.28-5.644-1.1m-2.623.935C6.707 9.337 5.623 10.592 5 12.179c1.603 3.452 4.02 5.178 7.25 5.178 1.497 0 2.819-.37 3.966-1.112m-5.188-5.191a1.793 1.793 0 0 0-.39 1.125c0 .953.722 1.726 1.612 1.726.452 0 .86-.2 1.153-.52m-1.592-1.651a.67.67 0 0 0-.165.445c0 .357.27.647.604.647a.583.583 0 0 0 .427-.19M5.5 5.5l13 13",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgVisibilityOff as ReactComponent };
export default __webpack_public_path__ + "37d5405d257af048d84e99c867313f11.svg";